import {useTheme} from 'native-base';

const useColors = () => {
    const {colors} = useTheme();

    return colors;
};

export default useColors;
